import i18n from "../../resources/I18n";
import "./texteHautQuestionnaire.css";

interface ITexteHautQuestionnaireProps {
  estPlusieursAssures?: boolean;
}

function ObtenirTexteIntroduction(estPlusieursAssures: boolean) {
  return (
    <div className="sous-texte-questionnaire-amc" data-testid="texte-intro-amc">
      <p>{i18n.t("amc:texte-introduction-sb")}</p>
      {estPlusieursAssures && <p>{i18n.t("amc:texte-introduction-b1")}</p>}
    </div>
  );
}

function TexteHautQuestionnaire(props: Readonly<ITexteHautQuestionnaireProps>) {
  return (
    <>
      <h2 className="titre-questionnaire-amc" id="obtenir-reponse-maintenant-amc">
        {i18n.t("amc:obtenir-reponse-maintenant")}
      </h2>
      {ObtenirTexteIntroduction(props.estPlusieursAssures)}
    </>
  );
}

export default TexteHautQuestionnaire;
